import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
    Col,
    Container,
    Row,
    Spinner
} from "reactstrap";


import GroupService from "../Services/GroupService";

import { GroupDto } from "../types/Group";

import InstituteQuotation from "../Components/InstituteQuotation";
import GroupJoinStatus from "../Components/GroupJoinStatus";
import CommunityDiscussion from "../Components/CommunityDiscussion";
import { useAuth } from "../../../context/AuthContext";
import LearningPreferenceCard from "../Components/LearningPreferenceCard";
import CourseHeroSection from "../Components/New_Components_for_Details/CourseHeroSection";
import HowItWorks from "../Components/New_Components_for_Details/HowItWorks";
import FAQ from "../Components/New_Components_for_Details/FAQ";
import GroupInfo from "../Components/Groupinfo";
import Footer from "../../../common/Dashboard/Footer";
import Whatnext from "../Components/New_Components_for_Details/Whatnext";
import ProductHeroSection from "../Components/Products/ProductHerosection";
import ProductFAQ from "../Components/Products/ProductFAQ";
import ProductHowItWorks from "../Components/Products/ProductHowItWorks";
import ProductInfo from "../Components/Products/ProductInfo";

const GroupDetailsPage = () => {

    const { slug } = useParams();
    const { isAuthenticated } = useAuth();

    const [loading, setLoading] = useState(true);

    const [group, setGroup] =
        useState<GroupDto | null>(null);

    const [isMember, setIsMember] =
        useState(false);

    useEffect(() => {

        if (slug) {

            loadGroup();

        }

        // eslint-disable-next-line
    }, [slug]);

    const loadGroup = async () => {

        if (!slug)
            return;

        setLoading(true);

        try {

            const response =
                await GroupService.getBySlug(slug);

            setGroup(response);

        }
        catch (error) {

            console.error(error);

        }
        finally {

            setLoading(false);

        }

    };

    if (loading)
        return (

            <Container className="text-center mt-5">

                <Spinner />

            </Container>

        );

    if (!group)
        return (

            <Container className="mt-5">

                <h3>Group Not Found</h3>

            </Container>

        );

    return (

        <>
            {/* <Container className="py-4">         

            <CourseHeroSection group={group} />
            <GroupJoinStatus
                groupId={group.groupId}
                onStatusChanged={setIsMember}
            />

            <Row className="d-flex align-items-center mt-3">
                <Col lg={6} md={6} sm={12}>
                    <LearningPreferenceCard
                        groupId={group.groupId}
                        isMember={isMember}
                    />
                </Col>

                <Col lg={6} md={6} sm={12} className=" justify-content-end">
                    <LiveGroupStatus count={group.totalMembers} />

                </Col>
            </Row>


            <hr />

            {isMember && (
                <>
                    <CommunityDiscussion
                        groupId={group.groupId}
                        isJoined={true}
                        coordinatorName={group.coordinatorName ?? ""}
                        totalMembers={group.totalMembers}
                    />


                </>
            )}

            <HowItWorks groupName={group.groupName} />
 

            <div className="mt-5">

                <InstituteQuotation
                    groupName={group.groupName}
                    onQuotationClick={() => {

                        console.log("Open quotation form");

                    }}
                />

            </div>

            <FAQ />

        </Container> */}


            <Container fluid className="bg-light py-5">

                <Container>
                    <Row className="g-4 align-items-center">

                        <Col lg={10}>
                            {group.type === "Course" ? (<><CourseHeroSection group={group} /></>) : (<><ProductHeroSection group={group} /></>)}

                        </Col>

                        {!isAuthenticated && <Whatnext />}

                        <Row className="g-4 my-5">



                            <Col lg={12}>

                                {isMember ? (
                                    <>
                                        {group.type === "Course" && (<LearningPreferenceCard
                                            groupId={group.groupId}
                                            isMember={isMember}
                                        />)}


                                    </>) : (
                                    <>

                                        <div className="sticky-top" style={{ top: "90px" }}>


                                            <div className="mt-3">
                                                <GroupJoinStatus
                                                    groupId={group.groupId}
                                                    onStatusChanged={setIsMember}
                                                />
                                            </div>

                                        </div>

                                    </>)}

                            </Col>

                        </Row>



                    </Row>
                </Container>


                {isMember && (<>
                    <section className="py-5">

                        <Container>

                            <h2 className="fw-bold mb-4">
                                Community Discussion
                            </h2>

                            <CommunityDiscussion
                                groupId={group.groupId}
                                isJoined={true}
                                coordinatorName={group.coordinatorName ?? ""}
                                totalMembers={group.totalMembers}
                            />

                        </Container>

                    </section>

                </>)}



                <section className="py-5 bg-white" style={{ marginTop: "-100px" }}>
                    <Container>
                        {group.type === "Course" ? (<> <GroupInfo /></>) : (<><ProductInfo /></>)}


                    </Container>
                </section>


                <section className="py-5">
                    <Container>
                        {group.type === "Course" ? (<><HowItWorks groupName={group.groupName} /></>) : (<><ProductHowItWorks groupName={group.groupName} /></>)}


                    </Container>
                </section>


                {group.type === "Course" && (<section className="py-5 bg-white">
                    <Container>


                        {/* <p className="text-center text-muted mb-5">
                            Compare quotations collected by students and our coordinator.
                        </p> */}

                        <InstituteQuotation
                            groupName={group.groupName}
                            onQuotationClick={() => { }}
                        />

                    </Container>
                </section>)}






                {/* {isMember && (

                    <section className="py-5 bg-white">

                        <Container>

                            <LearningPreferenceCard
                                groupId={group.groupId}
                                isMember={isMember}
                            />

                        </Container>

                    </section>

                )} */}


                <section className="py-5">
                    <Container>
                        {group.type === "Course" ? (<><FAQ /></>) : (<><ProductFAQ /></>)}

                    </Container>
                </section>

            </Container>

            <Footer />
        </>

    );

};

export default GroupDetailsPage;